import React, { Component } from "react";
import { mensajeExito } from "../../../generico/MensajeSistemaToast"
import DataTable from 'react-data-table-component';
import history from "../../login/history"
import DatosSocio from "../../../generico/DatosSocio"
import ConfigService from "../../../../services/configuracion/ConfigService";
import Popup from "react-popup";
import { separadorPuntoMiles } from "../../../generico/utils/FormatoInput";
import { mayusculaPrimeraLetra } from "../../../generico/utils/FormatoInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

export default class AgregarSubsidioPaso5 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.tipo="";
    this.identificador=""
    this.montoPorcentaje = "";
  }

  getInitialState = () => ({
    datosCuenta: undefined
  })

  componentDidMount() {
  
  }

  notifiPopup = (titulo, mensaje) =>
  Popup.register({
    title: titulo,
    content: mensaje,
    buttons: {
      right: [
        {
          text: "Aceptar",
          className: "success",
          action: function () {
            Popup.close();
          },
        },
      ],
    },
  });


  getColumn() {
    return [
      {
        name: "concepto",
        selector: "concepto",
      },
      {
        name: "valor",
        selector: "valor",
      }]
  }

  /*****************
 * CARGAR TABLAS *
 *****************/

   loadDataTipo() {
  
    let _itemsConfirm = [];
    
    _itemsConfirm = [
      {
        concepto: "Cuenta a Acreditar",
        valor: this.props.respuestasData.idAhorro,
      },
      { concepto: "Tipo de Subsidio", valor: this.props.respuestasData.tipoDescripcion },
      { concepto: "Clase de Subsidio", valor: this.props.respuestasData.claseDescripcion },
      { concepto: "Fecha Hecho", valor: this.props.respuestasData.fechaHecho },
    ];
      return _itemsConfirm;
    }

  loadDataReposo() {
    let _itemsConfirm = [];
    _itemsConfirm = [
      { concepto: "Cantidad de Días", valor: this.props.respuestasData.cantDiasSubsidio },
      { concepto: "Diagnóstico Médico", valor: this.props.respuestasData.diagnostico },
      { concepto: "Hospital", valor: this.props.respuestasData.hospitalDescripcion },
      { concepto: "Nombre del Médico", valor: this.props.respuestasData.medicoDescripcion },
    ];
      return _itemsConfirm;
    }

  loadDataRecienNacido() {
    let _itemsConfirm = [];
    _itemsConfirm = [
      {
        concepto: "Nombre Completo",
        valor: `${this.props.respuestasData.primerApellidoRn} ${this.props.respuestasData.segundoApellidoRn || ""}, ${this.props.respuestasData.primerNombreRn} ${this.props.respuestasData.segundoNombreRn || ""}`,
      },
      { concepto: "Sexo", valor: this.props.respuestasData.sexoRn === "F" ? "Femenino" : "Masculino" },
      { concepto: "Fecha de Nacimiento", valor: this.props.respuestasData.fechaNacimientoRn },
      { concepto: "Nacionalidad", valor: this.props.respuestasData.nacRnDescripcion },
      { concepto: "Libro", valor: this.props.respuestasData.libro },
      { concepto: "Folio", valor: this.props.respuestasData.folio },
      { concepto: "Acta", valor: this.props.respuestasData.acta },
    ];
      return _itemsConfirm;
    }

  loadDataConyuge() {
    let _itemsConfirm = [];
    _itemsConfirm = [
      {
        concepto: "Nombre Completo",
        valor: `${this.props.respuestasData.primerApellidoCon} ${this.props.respuestasData.segundoApellidoCon || ""}, ${this.props.respuestasData.primerNombreCon} ${this.props.respuestasData.segundoNombreCon || ""}`,
      },
      { concepto: "Número de Cédula", valor: separadorPuntoMiles(this.props.respuestasData.cedulaCon) },
      { concepto: "Fecha de Nacimiento", valor: this.props.respuestasData.fechaNacimientoCon },
      { concepto: "Nacionalidad", valor: this.props.respuestasData.nacDescripcionCon },
    ];
      return _itemsConfirm;
    }


  VolverSubsidios = () => {
    history.push(ConfigService.getPathByName("solicitudSubsidios")?.url);
    window.location.reload();
  }

  render() {
    if( this.props.currentStep !== 7)
    return(<span />)
    if(this.props.currentStep === 7){
      mensajeExito("La solicitud se envió correctamente")
    }
    return (
      <div>
        <div className="row">
          <div className="steps clearfix steps-doc">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    
                    <span className="title_text current">
                      Selección de Cuenta
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    
                    <span className="title_text">
                      {this.props.respuestasData.claseSubsidio === 4
                        ? "Recién Nacido"
                        : this.props.respuestasData.claseSubsidio === 5
                        ? "Datos Conyuge"
                        : "Datos de Reposo"}
                    </span>
                  </div>
                </span>
              </li>
              {this.state.showNacimiento && (
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      
                      <span className="title_text">Datos Cónyuge</span>
                    </div>
                  </span>
                </li>
              )}
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    
                    <span className="title_text">Adjuntar Documentos</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-md-10" style={{ textAlign: "end" }}>
            <p className="nro-operacion">
              Número de operación: {this.props.respuestasData.respuestaServ}
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-md-10">
            <DatosSocio />
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-md-10">
            <span>
              Cuenta a Acreditar: {this.props.respuestasData.datosCuenta}
            </span>
            <div className="inner" style={{ paddingTop: 2, paddingBottom: 1 }}>
              <p style={{ margin: 0 }}>
                Tipo: {mayusculaPrimeraLetra(this.props.respuestasData.tipoDescripcion)}
              </p>
              <p style={{ margin: 1 }}>
                Clase: {mayusculaPrimeraLetra(this.props.respuestasData.claseDescripcion)}
              </p>
              <p style={{ margin: 1 }}>
                Fecha Hecho: {this.props.respuestasData.fechaHecho}
              </p>
                <h6 style={{ marginTop: '8px', fontSize: '1.1rem' }}>
                  Monto a Recibir: {separadorPuntoMiles(this.props.respuestasData.montoARecibir) + 'GS.'}
                </h6>
            </div>
          </div>
        </div>

        <br />

        <div className="row justify-content-md-center">
          <div className="col-md-8">
            {this.props.respuestasData.tipoSubsidio === 5 && (
              <DataTable
                columns={this.getColumn()}
                data={this.loadDataReposo()}
                title="Datos de Reposo"
                noTableHead={true}
                customStyles={{
                  rows: { style: { minHeight: "30px" } },
                }}
                getTheadGroupProps={() => {
                  return { style: { display: "none" } };
                }}
              />
            )}
            {this.props.respuestasData.claseSubsidio === 2 && (
              <DataTable
                columns={this.getColumn()}
                data={this.loadDataRecienNacido()}
                title="Datos del Recién Nacido"
                noTableHead={true}
                customStyles={{
                  rows: { style: { minHeight: "30px" } },
                }}
                getTheadGroupProps={() => {
                  return { style: { display: "none" } };
                }}
              />
            )}
            {this.props.respuestasData.tipoSubsidio === 4 && (
              <DataTable
                columns={this.getColumn()}
                data={this.loadDataConyuge()}
                title="Datos del Cónyuge"
                noTableHead={true}
                customStyles={{
                  rows: { style: { minHeight: "30px" } },
                }}
                getTheadGroupProps={() => {
                  return { style: { display: "none" } };
                }}
              />
            )}
          </div>
        </div>

        <br />

        <hr />

        <div className="row">
          <div className="col-lg-10 col-md-8"></div>
          <div className="col-lg-2 col-md-4">
          <button
                hidden
                className="btn btn-cu-quintary"
                onClick={this.VolverSubsidios}
              >
             <FontAwesomeIcon icon={faArrowLeft} />   Volver al Listado
              </button>
              {/* <button
                className="btn btn-cu-quintary"
                onClick={this.VolverSubsidios}
              >
               <FontAwesomeIcon icon={faArrowLeft} />  Volver al Listado
              </button> */}
          </div>
          
        </div>
      </div>
    );
  }
}